import Container from "../../components/layout/Container/Container";
import Header from "../../components/molecules/Header/Header";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import Stepwizard from "./Helper/Stepwizard";
import PersonalInformation from "./Helper/ProfileInformation";
import moment from "moment";
import { useState, useEffect } from "react";
import { SampleData } from "../../typings/models/SampleData";
import Select from "react-select";
import { getLabMaster, getSampleNames } from "../../api/apimethods";
import { ISampleSeverity } from "../../typings/models/SampleSeverity";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import { ISampleSignsSymptoms } from "../../typings/models/SampleSignsSymptoms";
import { ISampleDiseaseDistribution } from "../../typings/models/SampleDiseaseDistribution";
import { ISampleNameModel } from "../../typings/models/SampleNameModel";
import { IProjectDetails } from "../../typings/models/ProjectDetails";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/molecules/Loader";

const stepWizardConfig: IStepwizardProps = {
  currentStep: 3,
  steps: [
    {
      name: "Choose Application",
    },
    {
      name: "Samples & Tests",
    },
    {
      name: "Review",
    },
    {
      name: "Cost & Confirm",
    },
    {
      name: "Acknowledgement",
    },
  ],
};
const sampleLocationMapping: { [key: string]: string } = {
  "1": "Local",
  "2": "Foreign",
};
const Review = () => {
  const [samples, setSamples] = useState<SampleData[]>([]);
  const [severityOptions, setSeverityOptions] = useState<ISampleSeverity[]>([]);
  const [sampletypeOptions, setSampleTypeOptions] = useState<
    ICodeMasterModel[]
  >([]);

  const [signOrSymptomsOptions, setsignOrSymptomsOptions] = useState<
    ISampleSignsSymptoms[]
  >([]);
  const [diseaseDistributionOptions, setdiseaseDistributionOptions] = useState<
    ISampleDiseaseDistribution[]
  >([]);
  const [samplenameOptionsBak, setSampleNameOptionsBak] = useState<
    ISampleNameModel[]
  >([]);
  const [projectDetails, setProjectDetails] = useState<IProjectDetails>();
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const navigate = useNavigate();
  const [selectedOptions, setSelectedOptions] = useState(null);

  useEffect(() => {
    getMaster();
    const sampleLocalStorageStr: string =
      localStorage.getItem("sample-data") || "";
    if (sampleLocalStorageStr?.length) {
      let locallayStored = JSON.parse(sampleLocalStorageStr);
      setSamples(locallayStored);
    }
    const getProjDetails: string =
      localStorage.getItem("lab-project-details") || "";
    if (getProjDetails?.length) {
      let locallayStored: IProjectDetails = JSON.parse(getProjDetails);
      setProjectDetails(locallayStored);
    }
  }, []);

  const getMaster = async () => {
    setPageLoader(true);
    const response = await getLabMaster();
    if (response?.status == 200) {
      let masters = response.data.masters;
      setSampleTypeOptions(masters.sampleTypes);
      setsignOrSymptomsOptions(masters.signOrSymptoms);
      if (masters.severity) {
        let severity = masters.severity;
        let values: number[] = Object.values(severity);
        let severityArr: ISampleSeverity[] = Object.keys(severity).map(
          (x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          }
        );
        setSeverityOptions(severityArr);
      }
      setdiseaseDistributionOptions(masters.diseaseDistribution);
    }

    const response1 = await getSampleNames();
    setSampleNameOptionsBak(response1.data);

    setPageLoader(false);
  };

  const storeInLocalStorage = () => {
    localStorage.setItem("sample-data", JSON.stringify(samples));
    localStorage.setItem("lab-project-details", JSON.stringify(projectDetails));
  };

  const handlePreviousClick = () => {
    storeInLocalStorage();
    navigate("/samples-and-tests", { state: { shouldFetchData: true } });
  };

  const handleNextClick = () => {
    navigate("/cost-and-confirm");
  };

  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab"> Application for Laboratory Testing </div>
        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />
        <PersonalInformation />
        <div className="info-heading">
          <h3 className="info-h3">Samples & Details</h3>
        </div>
        {pageLoader ? (
          <Loader />
        ) : (
          samples &&
          samples.map((sample: SampleData, index: number) => {
            return (
              <div className="personal-info" key={sample.id}>
                <div className="clonable-block" data-toggle="cloner">
                  <div className="clonable" data-clone-number="1">
                    <div className="info-heading">
                      <h2>{`Sample ${index + 1}`}</h2>
                    </div>

                    <div className="info-content">
                      <div className="table-responsive mt-2 mb-2 ">
                        <table className="table table-striped product_table start_table">
                          <thead>
                            <tr>
                              <th className="w-34" colSpan={2}>
                                Sample Type
                                <span className="star-red">*</span>
                              </th>
                              <th className="w-34" colSpan={2}>
                                Sample Name
                                <span className="star-red">*</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan={2}>
                                <select
                                  className={`form-select ${
                                    !sample.sampleType
                                      ? "border-danger op05"
                                      : ""
                                  }`}
                                  aria-label="Default select example"
                                  id="sampleType"
                                  value={sample.sampleType}
                                  name="sampleType"
                                  disabled
                                >
                                  <option value=""></option>
                                  {sampletypeOptions &&
                                    sampletypeOptions.map((option, index) => (
                                      <option
                                        data-stid={option.id}
                                        key={index}
                                        value={option.name}
                                      >
                                        {option.name}
                                      </option>
                                    ))}
                                </select>{" "}
                                {sampletypeOptions &&
                                  sampletypeOptions.some(
                                    (option) => option.name === "OTHERS"
                                  ) &&
                                  sample.sampleType === "OTHERS" && (
                                    <input
                                      type="text"
                                      name="sampleTypeText"
                                      className={`form-control mt-2 ${
                                        sample?.sampleTypeErrMsg
                                          ? "border-danger"
                                          : ""
                                      }`}
                                      placeholder="Enter Sample Type"
                                      disabled
                                      value={sample.sampleTypeText}
                                    />
                                  )}
                              </td>
                              <td colSpan={2}>
                                <select
                                  className={`form-select ${
                                    !sample.sampleName
                                      ? "border-danger op05"
                                      : ""
                                  }`}
                                  aria-label="Default select example"
                                  id="sampleName"
                                  name="sampleName"
                                  value={sample.sampleName}
                                  disabled
                                >
                                  <option value=""></option>
                                  {sample?.sampleNameOptions &&
                                    sample?.sampleNameOptions.map(
                                      (nameOption, index) => (
                                        <option
                                          key={index}
                                          value={nameOption.name}
                                        >
                                          {nameOption.name}
                                        </option>
                                      )
                                    )}
                                  {Array.isArray(sample?.sampleNameOptions) &&
                                    sample?.sampleNameOptions.length === 0 && (
                                      <option value="OTHERS">OTHERS</option>
                                    )}
                                </select>

                                {sample?.sampleName === "OTHERS" && (
                                  <input
                                    type="text"
                                    name="sampleNameText"
                                    className={`form-control mt-2 ${
                                      sample?.sampleNameErrMsg
                                        ? "border-danger"
                                        : ""
                                    }`}
                                    placeholder="Enter Sample Name"
                                    value={sample.sampleNameText}
                                    disabled
                                  />
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={2}>
                                <label
                                  htmlFor="gpsCoordinate"
                                  className="col-form-label"
                                >
                                  Sample Desc
                                  <span className="star-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="sampleDesc"
                                  className={`form-select ${
                                    !sample.sampleDesc
                                      ? "border-danger op05"
                                      : ""
                                  }`}
                                  placeholder="Enter Sample Description"
                                  value={sample.sampleDesc}
                                  disabled
                                />
                                {sample?.sampleDesc === "Others" && (
                                  <input
                                    type="text"
                                    name="sampleDescText"
                                    className="form-control mt-2"
                                    placeholder="Enter Sample Description"
                                    value={sample.sampleDescText}
                                    disabled
                                  />
                                )}
                              </td>

                              <td colSpan={2}>
                                <label
                                  htmlFor="gpsCoordinate"
                                  className="col-form-label"
                                >
                                  Scientific Name
                                </label>
                                <input
                                  type="text"
                                  name="sampleDesc"
                                  className="form-select"
                                  placeholder=""
                                  value={
                                    sample.sampleType === "POTTING MEDIUM /SOIL"
                                      ? null
                                      : sample.scientificName
                                  }
                                  disabled
                                />
                              </td>
                            </tr>

                            <tr>
                              <td className="fnt-wg">
                                <div className="mb-2 ">
                                  <label
                                    htmlFor="samplingDate"
                                    className="col-form-label"
                                  >
                                    Sample Marking{" "}
                                    <span className="star-red">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className={`form-control ${
                                      !sample.marking
                                        ? "border-danger op05"
                                        : ""
                                    }`}
                                    aria-label="Sample Marking"
                                    id="marking"
                                    name="marking"
                                    value={sample.marking}
                                    disabled
                                  />
                                </div>
                              </td>
                              <td className="fnt-wg">
                                <div className="mb-2 ">
                                  <label
                                    htmlFor="samplingDate"
                                    className="col-form-label"
                                  >
                                    Sampling Date & Time
                                    <span className="star-red">*</span>
                                  </label>
                                  <input
                                    type="datetime-local"
                                    className={`form-control ${
                                      !sample.samplingDate
                                        ? "border-danger op05"
                                        : ""
                                    }`}
                                    id="samplingDate"
                                    name="samplingDate"
                                    value={
                                      sample.samplingDate
                                        ? moment(
                                            sample.samplingDate,
                                            "DD/MM/YYYY hh:mm A"
                                          ).format("YYYY-MM-DDTHH:mm")
                                        : ""
                                    }
                                    disabled
                                  />
                                </div>
                              </td>
                              <td className="fnt-wg" colSpan={2}>
                                <div className="mb-2 ">
                                  <label
                                    htmlFor="samplingDate"
                                    className="col-form-label"
                                  >
                                    Test Information{" "}
                                    <span className="star-red">*</span>
                                  </label>
                                  <button
                                    className="btn btn-outline-success w-100"
                                    type="button"
                                    disabled
                                  >
                                    Search Test
                                  </button>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan={3}
                                className="csp-w-20-percent"
                              >
                                {sample.labTestDetails &&
                                  sample.labTestDetails.map(
                                    (test, testIndex) => (
                                      <div
                                        className="test-detail"
                                        key={testIndex}
                                      >
                                        <span className="test-description">
                                          {test.testDescription}
                                        </span>
                                      </div>
                                    )
                                  )}
                              </td>
                            </tr>
                            <tr>
                              <td className="fnt-wg" colSpan={2}>
                                <div className="mb-2">
                                  <label
                                    htmlFor="selectedDistrict"
                                    className="col-form-label float-start"
                                  >
                                    District
                                    <span className="star-red">*</span>
                                  </label>
                                  <div className="input-group pos-rel">
                                    <input
                                      type="text"
                                      id="selectedDistrict"
                                      className={`form-control ${
                                        !sample.district
                                          ? "border-danger op05"
                                          : ""
                                      }`}
                                      placeholder=""
                                      value={sample.district}
                                      disabled
                                    />
                                  </div>
                                </div>
                              </td>

                              <td className="fnt-wg">
                                <div className="mb-2 ">
                                  <label
                                    htmlFor="severity"
                                    className="col-form-label"
                                  >
                                    Severity
                                    <span className="star-red">*</span>
                                  </label>

                                  <div className="pos-rel">
                                    <select
                                      className={`form-select ${
                                        !sample.severity
                                          ? "border-danger op05"
                                          : ""
                                      }`}
                                      aria-label="Default select example"
                                      id="severity"
                                      name="severity"
                                      value={sample.severity}
                                      disabled
                                    >
                                      <option value=""></option>
                                      {severityOptions &&
                                        severityOptions.map(
                                          (descOption, index) => (
                                            <option
                                              key={index}
                                              value={descOption.id}
                                            >
                                              {descOption.name}
                                            </option>
                                          )
                                        )}
                                    </select>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="fnt-wg">
                                <div className="mb-3 ">
                                  <label
                                    htmlFor="selectedCountry"
                                    className="col-form-label"
                                  >
                                    Country
                                    <span className="star-red">*</span>
                                  </label>

                                  <div className="input-group rounded">
                                    <input
                                      type="text"
                                      id="selectedCountry"
                                      className={`form-control rounded-start ${
                                        !sample.country
                                          ? "border-danger op05"
                                          : ""
                                      }`}
                                      placeholder=""
                                      value={sample.country}
                                      aria-label="Country"
                                      aria-describedby="search-addon"
                                      name="country"
                                      disabled
                                    />
                                  </div>
                                </div>
                              </td>
                              <td className="fnt-wg">
                                <div className="mb-3 ">
                                  <label
                                    htmlFor="selectedSampleLocation"
                                    className="col-form-label float-start"
                                  >
                                    Sample Location
                                    <span className="star-red">*</span>
                                  </label>

                                  <input
                                    type="text"
                                    className={`form-control ${
                                      !sample.sampleLocation
                                        ? "border-danger op05"
                                        : ""
                                    }`}
                                    aria-label="Sample Location"
                                    id="selectedSampleLocation"
                                    name="sampleLocation"
                                    value={
                                      sampleLocationMapping[
                                        sample.sampleLocation
                                      ] || ""
                                    }
                                    disabled
                                  />
                                </div>
                              </td>
                              <td className="fnt-wg" colSpan={2}>
                                <div className="mb-2 ">
                                  <label
                                    htmlFor="signsSymptoms"
                                    className="col-form-label"
                                  >
                                    Signs/Symptoms
                                    <span className="star-red">*</span>
                                  </label>

                                  <Select
                                    isMulti
                                    name="signsOrSymptoms"
                                    className={`basic-multi-select ${
                                      !sample.signsOrSymptoms
                                        ? "border-danger op05"
                                        : ""
                                    }`}
                                    classNamePrefix="select"
                                    value={
                                      Array.isArray(sample.signsOrSymptoms)
                                        ? sample.signsOrSymptoms.map(
                                            (value) => ({
                                              label: value,
                                              value: value,
                                            })
                                          )
                                        : []
                                    }
                                    isDisabled
                                  />
                                  {selectedOptions &&
                                    (selectedOptions as any[]).some(
                                      (option: any) => option.value === "Others"
                                    ) && (
                                      <input
                                        type="text"
                                        className="form-control mt-2"
                                        name="signsOrSymptomsText"
                                        placeholder="Enter Signs/Symptoms"
                                        value={sample.signsOrSymptomsText}
                                      />
                                    )}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="fnt-wg">
                                <div className="mb-2">
                                  <label
                                    htmlFor="gpsCoordinate"
                                    className="col-form-label"
                                  >
                                    Latitude(Decimal Degrees)
                                  </label>

                                  <div className="pos-rel">
                                    <input
                                      type="text"
                                      className={`form-control`}
                                      name="latitude"
                                      id="latitude"
                                      value={sample.latitude}
                                      disabled
                                    />
                                  </div>
                                </div>
                              </td>
                              <td className="fnt-wg">
                                <div className="mb-2">
                                  <label
                                    htmlFor="gpsCoordinate"
                                    className="col-form-label"
                                  >
                                    Longitude(Decimal Degrees)
                                  </label>

                                  <div className="pos-rel">
                                    <input
                                      type="text"
                                      className={`form-control`}
                                      name="longitude"
                                      id="longitude"
                                      value={sample.longitude}
                                      disabled
                                    />
                                  </div>
                                </div>
                              </td>
                              <td className="fnt-wg">
                                <div className="mb-2 ">
                                  <label
                                    htmlFor="diseaseDistribution"
                                    className="col-form-label"
                                  >
                                    Disease Distribution
                                    <span className="star-red">*</span>
                                  </label>

                                  <select
                                    className={`form-select ${
                                      !sample.diseaseDistribution
                                        ? "border-danger op05"
                                        : ""
                                    }`}
                                    aria-label="Default select example"
                                    name="diseaseDistribution"
                                    id="diseaseDistribution"
                                    value={sample.diseaseDistribution}
                                    disabled
                                  >
                                    <option value=""></option>
                                    {diseaseDistributionOptions &&
                                      diseaseDistributionOptions.map(
                                        (descOption, index) => (
                                          <option
                                            key={index}
                                            value={descOption.name}
                                          >
                                            {descOption.name}
                                          </option>
                                        )
                                      )}
                                  </select>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
        <div className="info-heading">
          <h3 className="info-h3">My Preference</h3>
        </div>
        {pageLoader ? (
          <Loader />
        ) : (
          <div className="personal-info">
            <div className="clonable-block">
              <div className="clonable">
                <div className="info-content">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3 row">
                        <label
                          className="col-sm-4 col-form-label"
                          htmlFor="showProjectInput"
                        >
                          Project Name/Location to be reflected in the report
                        </label>
                        <div className="col-sm-8">
                          <select
                            className="form-select"
                            id="showProjectInput"
                            name="showProjectInput"
                            value={projectDetails?.showProjectInput}
                            disabled
                          >
                            <option value="">---select---</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>
                      </div>

                      {projectDetails?.showProjectInput === "Yes" && (
                        <div className="mb-3 row">
                          <label
                            htmlFor="projectName"
                            className="col-sm-4 col-form-label"
                          >
                            Enter Project Name/Location for Report
                            <span className="star-red">*</span>
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              className={`form-control`}
                              placeholder=""
                              name="projectName"
                              value={projectDetails?.projectName}
                              disabled
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3 row">
                        <label
                          htmlFor="inputGroupFile04"
                          className="col-sm-4 col-form-label"
                        >
                          Support Documents
                        </label>
                        <div className="col-sm-8">
                          <div className="input-group">
                            {projectDetails?.attachmentName ? (
                              <div className="file-view">
                                {projectDetails?.attachmentName}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3 row">
                        <label
                          htmlFor="specialInstructions"
                          className="col-sm-4 col-form-label"
                        >
                          Special Instructions/Additional Information
                        </label>
                        <div className="col-sm-8">
                          <textarea
                            className="form-control"
                            placeholder=""
                            id="specialInstructions"
                            value={projectDetails?.specialInstruction}
                            disabled
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3 row">
                        <label
                          htmlFor="otherRemarks"
                          className="col-sm-4 col-form-label"
                        >
                          Other Remarks
                        </label>
                        <div className="col-sm-8">
                          <textarea
                            className="form-control"
                            placeholder=""
                            id="otherRemarks"
                            value={projectDetails?.otherRemarks}
                            disabled
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="text-end mt-3 mb-3">
          <button
            className="btn btn-d btn-secondary px-4"
            onClick={handlePreviousClick}
          >
            Previous
          </button>
          <button
            className="btn btn-d btn-primary nextBtn"
            name="next-click"
            type="button"
            onClick={handleNextClick}
          >
            Next
          </button>
        </div>
      </Container>
    </>
  );
};
export default Review;
